import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import { connect } from 'react-redux'
import { withDevice } from '@blazar-plugins/device'
import { Link } from 'blocket-ui'

import { buildListUrl } from 'utils/url'

const sharedStyle = css`
  font-size: 15px;
  color: #696766;
`

export const StyledLink = styled(Link)`
  ${sharedStyle}

  &:hover {
    color: #696766;
    text-decoration: underline;
  }
  &:active {
    color: #696766;
  }

  /* Raise above the card link */
  position: relative;
  z-index: 1;
`
export const NoLink = styled.span`
  ${sharedStyle}
`

export const TopInfoLink = ({ paramsByQueryKey, newQuery, children, onClick, device }) => {
  // Just render the children if we don't have a new query
  // This is true for example in the toplisting
  // Or if we are on mobile, it might be confusing if the user
  // clicks the card and for some reason goes to a new LI
  // page instead of VI
  if (!newQuery || !device.is('medium')) {
    return <NoLink>{children}</NoLink>
  }

  return (
    <StyledLink to={buildListUrl(newQuery, paramsByQueryKey)} onClick={onClick}>
      {children}
    </StyledLink>
  )
}

TopInfoLink.propTypes = {
  paramsByQueryKey: PropTypes.object.isRequired,
  device: PropTypes.object.isRequired,
  newQuery: PropTypes.object,
  children: PropTypes.node,
  onClick: PropTypes.func,
}

const mapStateToProps = (state) => ({
  paramsByQueryKey: state.searchParams.byQueryKey,
})

export default withDevice(connect(mapStateToProps)(TopInfoLink))
